// Real driver teammate pairings, matched by driver name.
//
// Two drivers count as "ex-teammates" for synergy ONLY if they actually raced
// together at the same constructor in at least one shared season. Sharing a
// constructor in *different* eras does NOT count: Prost and Alonso both drove
// for McLaren, but years apart, so they were never teammates.
//
// Every entry documents the constructor and the shared season(s) so the list
// stays auditable. Both names in a pair must exist in the driver pool.
const PAIRS: ReadonlyArray<readonly [string, string]> = [
  ["Senna", "Prost"], //          McLaren 1988–89
  ["Senna", "Berger"], //         McLaren 1990–92
  ["Prost", "Lauda"], //          McLaren 1984–85
  ["Prost", "Mansell"], //        Ferrari 1990
  ["Mansell", "Patrese"], //      Williams 1991–92
  ["Mansell", "Piquet"], //       Williams 1986–87
  ["Patrese", "Piquet"], //       Brabham 1982–83
  ["Hill", "J. Villeneuve"], //   Williams 1996
  ["Hill", "Coulthard"], //       Williams 1994–95
  ["Schumacher", "Barrichello"], //Ferrari 2000–05
  ["Schumacher", "Irvine"], //    Ferrari 1996–99
  ["Schumacher", "Herbert"], //   Benetton 1995
  ["Vettel", "Webber"], //        Red Bull 2009–13
  ["Vettel", "Raikkonen"], //     Ferrari 2015–18
  ["Hamilton", "Rosberg"], //     Mercedes 2013–16
  ["Hamilton", "Bottas"], //      Mercedes 2017–21
  ["Hamilton", "Button"], //      McLaren 2010–12
  ["Hamilton", "Alonso"], //      McLaren 2007
  ["Verstappen", "Perez"], //     Red Bull 2021–24
  ["Verstappen", "Tsunoda"], //   Red Bull 2025
  ["Norris", "Piastri"], //       McLaren 2023–25
  ["Alonso", "Fisichella"], //    Renault 2005–06
  ["Alonso", "Massa"], //         Ferrari 2010–13
  ["Alonso", "Raikkonen"], //     Ferrari 2014
  ["Alonso", "Button"], //        McLaren 2015–16
  ["Jones", "Reutemann"], //      Williams 1980–81
  ["Button", "Barrichello"], //   Honda 2006–08, Brawn 2009
  ["Raikkonen", "Massa"], //      Ferrari 2007–09
  ["Raikkonen", "Coulthard"], //  McLaren 2002–04
  ["Raikkonen", "Montoya"], //    McLaren 2005
  ["Hakkinen", "Coulthard"], //   McLaren 1996–2001
  ["Coulthard", "Webber"], //     Red Bull 2007–08
  ["Massa", "Bottas"], //         Williams 2014–16
  ["Fittipaldi", "Peterson"], //  Lotus 1973
  ["Senna", "De Angelis"], //     Lotus 1985
  ["Stroll", "Massa"], //         Williams 2017
  ["Leclerc", "Hamilton"], //     Ferrari 2025
  ["Leclerc", "Sainz"], //        Ferrari 2019–24
  ["Russell", "Hamilton"], //     Mercedes 2022–24
  ["Russell", "Antonelli"], //    Mercedes 2025
  ["Albon", "Sainz"], //          Williams 2025
  ["Albon", "Verstappen"], //     Red Bull 2019–20
  ["Ricciardo", "Verstappen"], // Red Bull 2016–18
  ["Ricciardo", "Vettel"], //     Red Bull 2014
  ["Ricciardo", "Norris"], //     McLaren 2021–22
  ["Ricciardo", "Ocon"], //       Renault 2020
  ["Colapinto", "Gasly"], //      Alpine (Renault) 2025
  ["Colapinto", "Albon"], //      Williams 2024
];

const key = (a: string, b: string): string => (a < b ? `${a}|${b}` : `${b}|${a}`);

const TEAMMATE_KEYS: ReadonlySet<string> = new Set(PAIRS.map(([a, b]) => key(a, b)));

/** Were these two drivers genuinely teammates in at least one real season? */
export const areTeammates = (a: string, b: string): boolean => TEAMMATE_KEYS.has(key(a, b));
